export const GOOGLE_TAG_MANAGER_ID = "GTM-PS7457W";
